import type { SavedSearch } from 'bundles/connect/types';

export const SET_SAVED_SEARCH = 'SET_SAVED_SEARCH';

export function setSavedSearch(val: SavedSearch) {
  return {
    type: SET_SAVED_SEARCH,
    payload: val
  };
}
